if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

  //  getSelectedVariant(productInfoNode) {
  //   const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;

  //   console.log("selectedVariant", selectedVariant);

  //   if (!selectedVariant) return null;

  //   const variantObject = JSON.parse(selectedVariant);

  //   return variantObject;
  // }

getSelectedVariant(productInfoNode) {
  const selectedVariantJSON =
    productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;

  if (selectedVariantJSON) {
    try {
      return JSON.parse(selectedVariantJSON);
    } catch (e) {
      console.error("Variant JSON parsing error:", e);
    }
  }

  const productJSON = productInfoNode.querySelector('[data-product-json]')?.textContent;

  if (productJSON) {
    try {
      const productObj = JSON.parse(productJSON);
      return productObj?.variants?.[0] || null;
    } catch (e) {
      console.error("Product JSON parse error:", e);
    }
  }

  console.warn("No variant or product JSON found.");
  return null;
}


updateCustomButtons(isOutOfStock, variant) {
  const inStockButton = this.querySelector('.btn-in-stock');
  const outOfStockButton = this.querySelector('.btn-out-of-stock');
  if (!inStockButton || !outOfStockButton) return;
  // Toggle buttons
  if (isOutOfStock) {
    inStockButton.classList.add('hidden');
    outOfStockButton.classList.remove('hidden');
  } else {
    // inStockButton.classList.remove('hidden');
    outOfStockButton.classList.add('hidden');
  }

  // Update each form
  this.querySelectorAll(
    `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
  ).forEach((productForm) => {
    // Update variant ID for the form
    const idInput = productForm.querySelector('input[name="id"]');
    if (idInput && variant) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Handle backorder input inside this form
    // let backorderInput = productForm.querySelector('input[name="properties[Order Type]"]');
    // if (isOutOfStock && variant) {
    //   if (!backorderInput) {
    //     backorderInput = document.createElement('input');
    //     backorderInput.type = 'hidden';
    //     backorderInput.name = 'properties[Order Type]';
    //     productForm.appendChild(backorderInput);
    //   }
    //   backorderInput.value = `Backorder - Variant ID: ${variant.id}`;
    // } else if (backorderInput) {
    //   backorderInput.remove();
    // }
  });
}


connectedCallback() {
  this.initializeProductSwapUtility();

  this.onVariantChangeUnsubscriber = subscribe(
    PUB_SUB_EVENTS.optionValueSelectionChange,
    this.handleOptionValueChange.bind(this)
  );

  this.initQuantityHandlers();

  // --- ADD THIS BLOCK TO HANDLE BUTTONS ON PAGE LOAD ---
  const initialVariant = this.getSelectedVariant(this);
  const isOutOfStock = !initialVariant || initialVariant.inventory_quantity <= 0;
  this.updateCustomButtons(isOutOfStock, selectedVariant);

  this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
}



      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }
      
      // Inside your ProductInfo class
matchPrices() {
  const working = this.querySelector('.working-price');
  const custom = this.querySelector('.custom-price');
  const customtwo = this.querySelector('.custom-price-two');

  if (working && custom && customtwo) {
    const workingValue = working.innerHTML.trim();
    const customValue = custom.innerHTML.trim();

    if (workingValue !== customValue) {
      custom.innerHTML = workingValue;
      customtwo.innerHTML = workingValue;
      // console.log("Custom prices updated to match working price:", workingValue);
    }
  }
}

connectedCallback() {
  this.initializeProductSwapUtility();

  this.onVariantChangeUnsubscriber = subscribe(
    PUB_SUB_EVENTS.optionValueSelectionChange,
    this.handleOptionValueChange.bind(this)
  );

  this.initQuantityHandlers();

  const initialVariant = this.getSelectedVariant(this);
  const isOutOfStock = !initialVariant || initialVariant.inventory_quantity <= 0;
  this.updateCustomButtons(isOutOfStock, initialVariant);

  // Run on page load
  this.matchPrices();

  // Observe dynamic DOM changes
  this.priceObserver = new MutationObserver(() => this.matchPrices());
  this.priceObserver.observe(this, { childList: true, subtree: true });

  this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
}

disconnectedCallback() {
  this.onVariantChangeUnsubscriber();
  this.cartUpdateUnsubscriber?.();

  // Disconnect observer to prevent memory leaks
  this.priceObserver?.disconnect();
}


      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          // CUSTOM REAL INVENTORY CHECK
const isOutOfStock = variant && variant.inventory_quantity <= 0;


// Show / hide custom buttons
this.updateCustomButtons(isOutOfStock);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

     updateVariantInputs(variantId) {
  // Update all forms
  this.querySelectorAll(
    `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
  ).forEach((productForm) => {
    const input = productForm.querySelector('input[name="id"]');
    if (input) {
      input.value = variantId ?? '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // ALSO update the standalone hidden input with class "product-variant-id"
  const hiddenInput = this.querySelector('input.product-variant-id');
  if (hiddenInput) {
    hiddenInput.value = variantId ?? '';
    hiddenInput.disabled = !variantId; // optional, disable if no variant selected
  }
}


      

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });

          // Also update thumbnail list to match main slider order
          this.syncThumbnailOrder();
          
          // Update Swiper sliders after DOM manipulation (only if DOM was changed)
          this.updateSwiperSliders(variantFeaturedMediaId);
        } else {
          // Even if no DOM changes, still update sliders to ensure they're in sync
          this.updateSwiperSliders(variantFeaturedMediaId);
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

         /**
       * Syncs thumbnail order to match main slider order
       */
      syncThumbnailOrder() {
        const mediaGallery = this.querySelector('media-gallery');
        if (!mediaGallery) return;

        const mainSliderUl = this.querySelector('.gallery-slider ul, [id^="Slider-Gallery"]');
        const thumbnailUl = this.querySelector('.gallery-thumbs ul, [id^="Slider-Thumbnails"]');
        
        if (!mainSliderUl || !thumbnailUl) return;

        // Get main slides in current order
        const mainSlides = Array.from(mainSliderUl.querySelectorAll('li[data-media-id]'));
        const mainSlideOrder = mainSlides.map(slide => slide.dataset.mediaId);

        // Get thumbnails
        const thumbnails = Array.from(thumbnailUl.querySelectorAll('li[data-target]'));
        const thumbnailMap = new Map(thumbnails.map(thumb => [thumb.dataset.target, thumb]));

        // Reorder thumbnails to match main slider order
        mainSlideOrder.forEach((mediaId, index) => {
          const thumbnail = thumbnailMap.get(mediaId);
          if (thumbnail) {
            const currentThumb = thumbnailUl.querySelector(`li:nth-of-type(${index + 1})`);
            if (currentThumb !== thumbnail) {
              thumbnailUl.insertBefore(thumbnail, currentThumb);
            }
          }
        });
      }

      /**
       * Updates Swiper slider instances after DOM manipulation.
       * Fixes issue where slider thumbnails don't work correctly after variant changes
       * because Swiper's internal state gets out of sync with the DOM.
       * 
       * @param {number} variantFeaturedMediaId - The featured media ID for the selected variant
       */
      updateSwiperSliders(variantFeaturedMediaId) {
        // Find Swiper instances by their container elements
        const gallerySliderEl = this.querySelector('.gallery-slider');
        const galleryThumbsEl = this.querySelector('.gallery-thumbs');
        
        if (!gallerySliderEl || !galleryThumbsEl) return;

        // Get Swiper instances from the elements (Swiper attaches itself to the element)
        // Try multiple methods to get the instance
        let mainSlider = gallerySliderEl.swiper;
        let thumbsSlider = galleryThumbsEl.swiper;

        // Fallback: Try to get instance using Swiper's getInstance method if available
        if (!mainSlider && typeof Swiper !== 'undefined' && Swiper.getInstance) {
          mainSlider = Swiper.getInstance(gallerySliderEl);
        }
        if (!thumbsSlider && typeof Swiper !== 'undefined' && Swiper.getInstance) {
          thumbsSlider = Swiper.getInstance(galleryThumbsEl);
        }

        // Fallback: Try to find in global scope (if sliders were initialized globally in custom.js)
        if (!mainSlider && typeof window !== 'undefined') {
          // Check if sliders are stored as global variables (from custom.js)
          if (window.slider && window.slider.el && window.slider.el === gallerySliderEl) {
            mainSlider = window.slider;
          }
        }
        if (!thumbsSlider && typeof window !== 'undefined') {
          if (window.thumbs && window.thumbs.el && window.thumbs.el === galleryThumbsEl) {
            thumbsSlider = window.thumbs;
          }
        }

        if (!mainSlider || !thumbsSlider) {
          console.warn('Swiper instances not found for gallery sliders');
          return;
        }

        // Find the index of the featured media slide
        const targetMediaId = `${this.dataset.section}-${variantFeaturedMediaId}`;
        const slides = Array.from(gallerySliderEl.querySelectorAll('.swiper-slide[data-media-id]'));
        const targetSlideIndex = slides.findIndex(slide => slide.dataset.mediaId === targetMediaId);

        // Use requestAnimationFrame to ensure DOM updates are complete
        requestAnimationFrame(() => {
          // Re-link thumbs to main slider FIRST - this is critical for functionality
          if (mainSlider.params && mainSlider.params.thumbs) {
            mainSlider.params.thumbs.swiper = thumbsSlider;
          }
          if (mainSlider.thumbs) {
            mainSlider.thumbs.swiper = thumbsSlider;
          }

          // Update both sliders to recognize new DOM structure
          // We need to update to recognize new slides, but do it carefully
          try {
            // Try to use updateSlides first (if available in this Swiper version)
            if (typeof mainSlider.updateSlides === 'function') {
              mainSlider.updateSlides();
              mainSlider.updateSize();
            } else {
              // Fallback to full update if updateSlides doesn't exist
              mainSlider.update();
            }
            
            if (typeof thumbsSlider.updateSlides === 'function') {
              thumbsSlider.updateSlides();
              thumbsSlider.updateSize();
            } else {
              thumbsSlider.update();
            }
            
            // Re-link thumbs AFTER update (update might have reset it)
            if (mainSlider.params && mainSlider.params.thumbs) {
              mainSlider.params.thumbs.swiper = thumbsSlider;
            }
            if (mainSlider.thumbs) {
              mainSlider.thumbs.swiper = thumbsSlider;
            }
          } catch (e) {
            console.warn('Error updating Swiper sliders:', e);
          }

          // Ensure thumbnail clicks work by adding click handlers
          this.reattachThumbnailClickHandlers();

          // Wait a bit before navigating to ensure everything is ready
          setTimeout(() => {
            // Verify sliders are still functional
            if (!mainSlider.destroyed && !thumbsSlider.destroyed) {
              const slides = Array.from(gallerySliderEl.querySelectorAll('.swiper-slide[data-media-id]'));
              
              if (targetSlideIndex !== -1 && targetSlideIndex < slides.length) {
                // Only navigate if we're not already on the correct slide
                if (mainSlider.activeIndex !== targetSlideIndex) {
                  // Navigate to the correct slide with smooth transition
                  mainSlider.slideTo(targetSlideIndex, 300);
                }
                
                // Update thumbnail slider to show the active thumbnail
                const thumbSlides = Array.from(galleryThumbsEl.querySelectorAll('.swiper-slide[data-target]'));
                const targetThumbIndex = thumbSlides.findIndex(thumb => thumb.dataset.target === targetMediaId);
                
                if (targetThumbIndex !== -1 && targetThumbIndex < thumbSlides.length) {
                  if (thumbsSlider.activeIndex !== targetThumbIndex) {
                    thumbsSlider.slideTo(targetThumbIndex, 300);
                  }
                }
              }
            }
          }, 100);
        });
      }

      /**
       * Reattaches thumbnail click handlers to ensure they work after DOM updates
       */
      reattachThumbnailClickHandlers() {
        const mediaGallery = this.querySelector('media-gallery');
        if (!mediaGallery || !mediaGallery.elements || !mediaGallery.elements.thumbnails) return;

        const galleryThumbsEl = this.querySelector('.gallery-thumbs');
        const gallerySliderEl = this.querySelector('.gallery-slider');
        if (!galleryThumbsEl || !gallerySliderEl) return;

        const thumbsSlider = galleryThumbsEl.swiper;
        const mainSlider = gallerySliderEl.swiper;
        if (!thumbsSlider || !mainSlider) return;

        // Remove any existing custom handlers to avoid duplicates
        if (thumbsSlider._customSlideChangeHandler) {
          thumbsSlider.off('slideChange', thumbsSlider._customSlideChangeHandler);
        }
        
        // Create a named handler function so we can remove it later
        // This handler ensures media-gallery state is updated when thumbnails change
        // Swiper's built-in thumbs should handle the main slider sync, but we need to update media-gallery
        let isUpdating = false;
        thumbsSlider._customSlideChangeHandler = () => {
          // Prevent infinite loops
          if (isUpdating) return;
          
          // Small delay to ensure Swiper's built-in thumbs sync has completed
          setTimeout(() => {
            if (isUpdating) return;
            isUpdating = true;
            
            try {
              const activeThumbIndex = thumbsSlider.activeIndex;
              const thumbSlides = galleryThumbsEl.querySelectorAll('.swiper-slide[data-target]');
              const activeThumb = thumbSlides[activeThumbIndex];
              
              if (activeThumb) {
                const mediaId = activeThumb.dataset.target;
                
                // Use media-gallery's setActiveMedia for proper state management
                // This ensures the media-gallery component knows which slide is active
                if (mediaGallery.setActiveMedia) {
                  mediaGallery.setActiveMedia(mediaId, false);
                }
              }
            } finally {
              isUpdating = false;
            }
          }, 100);
        };
        
        thumbsSlider.on('slideChange', thumbsSlider._customSlideChangeHandler);
      }


      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

